//
// Accordion
//

function init() {
  const accordionElement = document.querySelectorAll('.ce-accordion') || [];
  
  // click on span to avoid conflicts in search filters
  const accordionToggle = document.querySelectorAll('.ce-accordion-toggle') || [];
  
  if (accordionElement.length) {
    accordionToggle.forEach(function (el) {
      el.addEventListener('click', function () {
        accordionTrigger(el);
      }, false);
      el.addEventListener('keypress', function () {
        accordionTrigger(el);
      }, false);
    });
  }
  
  function accordionTrigger(el) {
    let ariaState = el.getAttribute('aria-expanded'),
        accordionToggleID = el.getAttribute('aria-controls'),
        accordionTitle = el.parentNode;

    if (ariaState == "false") {
      // open this accordion
      el.setAttribute('aria-expanded', 'true');
      accordionTitle.classList.add('expanded');
      accordionTitle.parentNode.classList.add('active');
      document.getElementById(accordionToggleID).classList.add('show');
    } else {
      // close this accordion
      el.setAttribute('aria-expanded', 'false');
      accordionTitle.classList.remove('expanded');
      accordionTitle.parentNode.classList.remove('active');
      document.getElementById(accordionToggleID).classList.remove('show');
    }
  }
}

export default {};

export const Init = init;
